export const LINK_ATTACHMENT_DIALOG_TITLE = 'link-attachment-dialog.title';
export const LINK_ATTACHMENT_DIALOG_ICON_ALT = 'link-attachment-dialog.icon-alt';
